<template>
  <div class="faq-page">
    <!-- Navbar Area -->
    <div class="navbar-area" :class="{ 'is-sticky': isSticky }">
      <div class="template-responsive-navbar">
          <div class="container">
              <div class="template-responsive-menubar">
                  <div class="logo">
                      <router-link to="/">
                        <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                      </router-link>
                  </div>
                  <div class="meanmenu-reveal" id="meanmenu-reveal" @click="toggleMobileMenu"><span></span></div>
              </div>
          </div>
          <!-- Mobile Menu -->
          <div class="mean-nav" :class="{ 'mean-show': isMobileMenuOpen }">
              <div class="mobile-menu-container">
                  <ul class="navbar-nav">
                    <li class="nav-item"><router-link to="/" class="nav-link" @click.native="handleMobileNavClick('/')">{{ t.home }}</router-link></li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'services')">{{ t.services }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'services' }">
                        <li class="nav-item"><router-link to="/dynamic" class="nav-link" @click.native="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</router-link></li>
                        <li class="nav-item"><router-link to="/static" class="nav-link" @click.native="handleMobileNavClick('/static')">{{ t.serviceStatic }}</router-link></li>
                      </ul>
                    </li>
                    
                    <li class="nav-item"><a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'blog')">{{ t.blog }} <i class="bx bx-plus dropdown-icon"></i></a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'blog' }">
                        <li class="nav-item"><router-link to="/faq" class="nav-link" @click.native="handleMobileNavClick('/faq')">{{ t.faq }}</router-link></li>
                      </ul>
                    </li>
                    
                    <!-- Language Switcher -->
                    <li class="nav-item">
                      <a href="#" class="dropdown-toggle nav-link" @click="toggleDropdown($event, 'language')">
                        {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }} <i class="bx bx-plus dropdown-icon"></i>
                      </a>
                      <ul class="dropdown-menu" :class="{ 'show': activeDropdown === 'language' }">
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')" style="padding: 10px 0 10px 20px;">English</button></li>
                        <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')" style="padding: 10px 0 10px 20px;">中文</button></li>
                      </ul>
                    </li>
                  </ul>
                  
                  <div class="others-option d-flex flex-column mt-4">
                    <div class="item mb-3">
                      <a href="/login" class="default-btn">{{ t.signIn }}</a>
                    </div>
                    
                    <div class="item">
                      <a href="/register" class="default-btn">{{ t.signUp }}</a>
                    </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="template-navbar">
        <div class="container">
          <nav class="navbar navbar-expand-md navbar-light">
            <router-link class="navbar-brand" to="/">
              <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
            </router-link>

            <button class="navbar-toggler" type="button" @click="isNavCollapsed = !isNavCollapsed" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse mean-menu" :class="{ 'show': !isNavCollapsed }">
              <ul class="navbar-nav">
                <li class="nav-item"><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.services }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/dynamic" class="nav-link">{{ t.serviceDynamic }}</router-link></li>
                    
                    <li class="nav-item"><router-link to="/static" class="nav-link">{{ t.serviceStatic }}</router-link></li>
                  </ul>
                </li>

                <li class="nav-item"><a href="#" class="dropdown-toggle nav-link">{{ t.blog }}</a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><router-link to="/faq" class="nav-link">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                
                <!-- Language Switcher -->
                <li class="nav-item">
                  <a href="#" class="dropdown-toggle nav-link">
                    {{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}
                  </a>
                  <ul class="dropdown-menu">
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('en')">English</button></li>
                    <li class="nav-item"><button class="nav-link language-option" @click="setLanguage('zh')">简体中文</button></li>
                  </ul>
                </li>
              </ul>

              <div class="others-option d-flex align-items-center">
                <div class="item">
                  <a href="/login" class="default-btn">{{ t.signIn }}</a>
                </div>

                <div class="item">
                  <a href="/register" class="default-btn">{{ t.signUp }}</a>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
    <!-- End Navbar Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.faqTitle }}</h1>
          <p>{{ t.faqSubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- FAQ Section -->
    <section class="faq-section ptb-100 bg-light">
      <div class="container">
        <div class="faq-content">
          <div class="faq-tabs">
            <div class="tabs-container">
              <div class="tab-buttons">
                <button 
                  v-for="tab in tabs" 
                  :key="tab.value"
                  :class="{ 'active': activeTab === tab.value }"
                  @click="activeTab = tab.value"
                  class="tab-btn"
                >
                  {{ tab.label }}
                </button>
              </div>
              
              <div class="tab-content">
                <!-- 入门 Tab -->
                <div v-if="activeTab === 'first'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.first" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.first === index }"
                      @click="toggleAccordion('first', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.first === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.first === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 价格 Tab -->
                <div v-if="activeTab === 'second'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.second" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.second === index }"
                      @click="toggleAccordion('second', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.second === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.second === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 账户 Tab -->
                <div v-if="activeTab === 'third'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.third" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.third === index }"
                      @click="toggleAccordion('third', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.third === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.third === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 故障 Tab -->
                <div v-if="activeTab === 'fourth'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.fourth" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.fourth === index }"
                      @click="toggleAccordion('fourth', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.fourth === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.fourth === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End FAQ Section -->

    <!-- Footer Section -->
    <footer class="footer-section pt-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.contactInfo }}</h3>
                        <ul class="footer-contact-info">
                            <!-- <li>Fish St Hill, Bridge, London EC3R 8AH, UK</li> -->
                            <li><a href="javascript:void(0);">super@proxylink.net</a></li>
                            <!-- <li><a href="tel:++254 25413 521">+254 25413 521</a></li>
                            <li><a href="tel:+254 25413 521">+254 25413 521</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget pl-4">
                        <h3>{{ t.usefulLinks }}</h3>
                        <ul class="links-list">
                            <!-- <li><a href="#">About Us</a></li> -->
                            <!-- <li><a href="#">Features</a></li> -->
                            <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                            <!-- <li><a href="#">Blog</a></li> -->
                            <!-- <li><a href="#">Contact</a></li> -->
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <h3>{{ t.support }}</h3>
                        <ul class="links-list">
                            <li><router-link to="/privacy">{{ t.privacyPolicy }}</router-link></li>
                            <li><router-link to="/service-policy">{{ t.servicePolicy }}</router-link></li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-6 col-md-6">
                    <div class="footer-widget">
                        <a href="/" class="logo d-inline-block">
                            <img :src="require('../assets/images/homelogo.png')" alt="ProxyLink logo" style="height: 55px; width: auto;">
                        </a>
                        <p>{{ t.welcomeText }}</p>
                        <ul class="social-links">
                            <li><a href="javascript:void(0);"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="javascript:void(0);"><i class="bx bxl-instagram"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="copyright-area">
            <div class="container">
                <p>{{ t.copyright }}</p>
            </div>
        </div>
    </footer>
    <!-- End Footer Section -->

    <div class="go-top" :class="{ 'active': showGoTop }" @click="scrollToTop"><i class='bx bx-up-arrow-alt'></i></div>
  </div>
</template>

<script>
export default {
  name: 'FAQPage',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      showGoTop: false,
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: null,
      activeTab: 'first',
      activeAccordion: {
        first: null,
        second: null,
        third: null,
        fourth: null
      }
    };
  },
  computed: {
    t() {
      const lang = this.languageState.currentLanguage;
      return {
        home: lang === 'zh' ? '首页' : 'Home',
        services: lang === 'zh' ? '套餐' : 'Package',
        serviceDynamic: lang === 'zh' ? '动态住宅' : 'Dynamic residence',
        serviceStatic: lang === 'zh' ? '静态住宅' : 'Static residence',
        blog: lang === 'zh' ? '教程中心' : 'Tutorial Center',
        faq: lang === 'zh' ? '常见问题' : 'FAQ',
        signIn: lang === 'zh' ? '登录' : 'Sign In',
        signUp: lang === 'zh' ? '注册' : 'Sign Up',
        faqTitle: lang === 'zh' ? '常见问题解答' : 'Frequently Asked Questions',
        faqSubtitle: lang === 'zh' ? '了解更多关于我们代理服务的信息' : 'Learn more about our proxy services',
        // Tabs
        tabGettingStarted: lang === 'zh' ? '入门' : 'Getting Started',
        tabPricing: lang === 'zh' ? '价格' : 'Pricing',
        tabAccount: lang === 'zh' ? '账户' : 'Account',
        tabTroubleshooting: lang === 'zh' ? '故障' : 'Troubleshooting',
        // FAQ Data - Getting Started
        faq1q: lang === 'zh' ? '使用IP代理为什么没有网络？' : 'Why is there no network when using IP proxy?',
        faq1a: lang === 'zh' ? '海外IP需要在境外环境上使用，如已经在境外环境，请检查服务器的IP地址是否添加到白名单' : 'Overseas IP needs to be used in an overseas environment. If you are already in an overseas environment, please check if the server IP address has been added to the whitelist.',
        faq2q: lang === 'zh' ? '什么是IP白名单？' : 'What is an IP whitelist?',
        faq2a: lang === 'zh' ? 'IP白名单是ProxyLink代理的验证机制，在使用代理服务时，需要先将使用代理的服务器IP添加到白名单，有以下两种形式：<br>（1）本机服务器使用代理：生成链接后，系统将提示添加本机服务器IP至白名单，确认添加后即可使用代理服务<br>（2）其他服务器使用代理：在ProxyLink账户后台添加IP白名单，支持添加多个IP白名单' : 'IP whitelist is the verification mechanism of ProxyLink proxy. When using proxy services, you need to add the server IP using the proxy to the whitelist first. There are two forms:<br>(1) Local server uses proxy: After generating a link, the system will prompt you to add the local server IP to the whitelist. After confirming the addition, you can use the proxy service.<br>(2) Other servers use proxy: Add IP whitelist in the ProxyLink account backend, supporting multiple IP whitelist additions.',
        faq3q: lang === 'zh' ? 'IP支持哪些协议？' : 'Which protocols does IP support?',
        faq3a: lang === 'zh' ? '支持HTTP、HTTPS、SOCKS5三种协议<br>官网获取的是HTTP、HTTPS，协议互通，在代理时设置请求协议直接代理即可；如果有获取不到的情况，可以联系客服进行协助处理' : 'Supports HTTP, HTTPS, and SOCKS5 protocols.<br>The official website provides HTTP and HTTPS, which are interoperable. When proxying, you can directly set the request protocol for proxying. If you cannot obtain it, you can contact customer service for assistance.',
        faq4q: lang === 'zh' ? 'IP使用有哪些限制？' : 'What are the limitations of IP usage?',
        faq4a: lang === 'zh' ? 'IP没有请求和并发限制，api链接提取频率是1秒1次，IP提取单次最多可达900个。有其他额外需求联系客服协助处理' : 'There are no request or concurrency limits for IP. The API link extraction frequency is 1 time per second, and the maximum number of IPs extracted at a time can reach 900. For other additional needs, contact customer service for assistance.',
        faq5q: lang === 'zh' ? '手机可以设置代理吗？' : 'Can mobile phones set up proxies?',
        faq5a: lang === 'zh' ? '手机同样需要境外环境，打开手机的WLAN设置，选择连接的无线网络；点击无线网络设置，代理设置点击手动；手动输入在ProxyLink获取的IP和端口' : 'Mobile phones also need an overseas environment. Open the phone\'s WLAN settings, select the connected wireless network; click wireless network settings, click manual for proxy settings; manually enter the IP and port obtained from ProxyLink.',
        faq6q: lang === 'zh' ? '获取的代理IP实际不是最终的出口IP' : 'The obtained proxy IP is not the final exit IP?',
        faq6a: lang === 'zh' ? 'IP为隧道转发，出口是真实IP，IP段一致，端口不同，每一个端口对应一个ip' : 'IP is tunnel forwarding, the exit is a real IP, the IP segment is consistent, ports are different, each port corresponds to an IP.',
        faq7q: lang === 'zh' ? '如何检查本地网络？' : 'How to check the local network?',
        faq7a: lang === 'zh' ? '您可以打开cmd输入curl ipinfo.io查看当前的IP地址' : 'You can open cmd and enter curl ipinfo.io to check the current IP address.',
        faq8q: lang === 'zh' ? 'ProxyLink推广计划能永久奖励吗？' : 'Can ProxyLink promotion plan give permanent rewards?',
        faq8a: lang === 'zh' ? '区别于其他的推广计划，ProxyLink不会限制您的奖励周期，永久收益！<br>（1）推荐新用户免费试用ProxyLink， 获3元/位现金奖励！<br>（2）推荐新用户购买获30%奖励，高至5000元！<br>（3）若用户复购，您可享受每笔订单5%奖励，每笔最高1000元， 立刻赚取奖励！' : 'Unlike other promotion plans, ProxyLink does not limit your reward period, permanent income!<br>(1) Recommend new users to try ProxyLink for free, get 3 yuan/cash reward!<br>(2) Recommend new users to purchase and get 30% reward, up to 5000 yuan!<br>(3) If users repurchase, you can enjoy 5% reward for each order, up to 1000 yuan per order, earn rewards immediately!',
        faq9q: lang === 'zh' ? 'ProxyLink代理覆盖哪些国家地区？' : 'Which countries and regions does ProxyLink proxy cover?',
        faq9a: lang === 'zh' ? '目前覆盖了包括美国、英国、加拿大、印度、韩国等热门国家在内的220多个国家和地区，<br>为用户提供超9000万IP数量，点击 此处了解更多国家及IP数量。' : 'Currently covering more than 220 countries and regions including popular countries such as the United States, the United Kingdom, Canada, India, South Korea, etc.,<br>providing users with more than 90 million IPs, click here to learn more about countries and IP quantities.',
        faq10q: lang === 'zh' ? 'ProxyLink提供哪些代理方案？' : 'What proxy solutions does ProxyLink provide?',
        faq10a: lang === 'zh' ? 'ProxyLink目前为您提供以下6种解决方案：<br>动态住宅、 静态住宅、 独享数据中心、 动态长效ISP、 动态数据中心、 移动代理。<br>另外，我们还提供“ 网页解锁工具”，实现网页爬虫率大于99.99%，一键发送请求，即可轻松获得最准确的数据。' : 'ProxyLink currently provides you with the following 6 solutions:<br>Dynamic Residential, Static Residential, Dedicated Data Center, Dynamic Long-term ISP, Dynamic Data Center, Mobile Proxy.<br>In addition, we also provide a "Web Unlock Tool" to achieve a web crawler rate of more than 99.99%, one-click send request, you can easily get the most accurate data.',
        faq11q: lang === 'zh' ? 'ProxyLink代理可运用于哪些业务场景？' : 'Which business scenarios can ProxyLink proxy be used for?',
        faq11a: lang === 'zh' ? 'ProxyLink代理可运用于以下业务场景：<br>品牌保护、广告验证、网站测试、股市数据、市场调查、竞争对手情报、抓取索引、邮件保护、<br>SEO监控优化、旅游信息聚合等，您的业务具体适用哪种代理，您可咨询 客户经理 为您解答。' : 'ProxyLink proxy can be used in the following business scenarios:<br>Brand protection, ad verification, website testing, stock market data, market research, competitor intelligence, crawling indexes, email protection,<br>SEO monitoring optimization, travel information aggregation, etc. Which proxy is suitable for your specific business, you can consult the account manager for answers.',
        // Footer translations
        contactInfo: lang === 'zh' ? '联系我们' : 'Contact Info',
        usefulLinks: lang === 'zh' ? '有用链接' : 'Useful Links',
        support: lang === 'zh' ? '支持' : 'Support',
        privacyPolicy: lang === 'zh' ? '隐私政策' : 'Privacy Policy',
        servicePolicy: lang === 'zh' ? '服务政策' : 'Service Policy',
        welcomeText: lang === 'zh' ? '欢迎尝试我们的产品！' : 'Welcome to try our products!',
        copyright: lang === 'zh' ? 'ProxyLink. © 2023 保留所有权利。' : 'ProxyLink. © 2023 All Rights Reserved.',
        // FAQ Data - Pricing (second tab)
        faq12q: lang === 'zh' ? '如何免费测试？' : 'How to test for free?',
        faq12a: lang === 'zh' ? '新用户注册后进行实名认证，添加白名单按照使用流程即可免费测试动态流量，个人认证送30元额度，免费试用230M流量，技术认证送80元额度，免费试用600M流量，企业认证送150元额度，免费试用1G流量' : 'After new users register, they can verify their identity, add a whitelist, and follow the usage process to test dynamic traffic for free. Personal authentication gives 30 yuan credit, free trial of 230M traffic; technical authentication gives 80 yuan credit, free trial of 600M traffic; enterprise authentication gives 150 yuan credit, free trial of 1G traffic.',
        faq13q: lang === 'zh' ? 'IP是怎么收费的？' : 'How are IPs charged?',
        faq13a: lang === 'zh' ? '动态IP按照流量进行收费，流量计算方式为：上行+下行，计算上传的流量加下载的流量总和；数据中心IP、静态住宅按照IP个数计费' : 'Dynamic IP is charged according to traffic, calculated as: upload + download, the sum of uploaded and downloaded traffic; data center IP and static residential are charged according to the number of IPs.',
        faq14q: lang === 'zh' ? '生成的API链接没有账号标识，如何计费' : 'The generated API link has no account identifier, how to charge?',
        faq14a: lang === 'zh' ? '通过白名单判定，只有服务器ip在白名单列表里才能获取和使用ip，否则是提取不了ip的，一个白名单IP只能在一个账号里使用，按照白名单所在账号扣除流量费用' : 'Determined by whitelist, only server IP in the whitelist can obtain and use IP, otherwise IP cannot be extracted. One whitelist IP can only be used in one account, and traffic fees are deducted according to the account where the whitelist is located.',
        faq15q: lang === 'zh' ? '支持开具发票吗？' : 'Do you support invoice issuance?',
        faq15a: lang === 'zh' ? '联系客服可以开具电子发票，纸质发票（专票）需要签订购买合同，电子发票没有金额限制，开票顺序是从大金额到小金额，金额小的开具有时效性，可能出现次月开具的情况' : 'Contact customer service to issue electronic invoices. Paper invoices (special invoices) require a purchase contract. There is no amount limit for electronic invoices. The invoice issuance order is from large to small amounts. Small amounts have a time limit and may be issued in the next month.',
        faq16q: lang === 'zh' ? '免费赠送流量用完后，会自动扣费吗？' : 'Will it automatically deduct fees after the free traffic is used up?',
        faq16a: lang === 'zh' ? '不会自动扣费，免费赠送的流量用完后，将无法继续获取代理，只有在购买套餐或充值后，按照价格计费使用。' : 'It will not automatically deduct fees. After the free traffic is used up, you will not be able to continue to obtain proxies. You can only use it according to the price after purchasing a package or recharging.',
        faq17q: lang === 'zh' ? '额度套餐有时效吗？额度会清空吗？' : 'Does the credit package have a time limit? Will the credit be cleared?',
        faq17a: lang === 'zh' ? '额度套餐是通过账户充值获得专属额度，账户额度没有时效限制<br>30天时效是首次充值时，首次使用代理的计费单价时效，30天内按照套餐优惠单价扣费 超过30天，按照原价计费：<br>动态住宅：130￥/GB<br>动态数据中心：20￥/GB<br>动态长效ISP：130￥/GB' : 'The credit package is obtained through account recharge. There is no time limit for account credit.<br>The 30-day validity period is the validity period of the billing unit price for the first use of the proxy when recharging for the first time. Within 30 days, it is deducted according to the package preferential unit price. After 30 days, it is charged according to the original price:<br>Dynamic Residential: 130￥/GB<br>Dynamic Data Center: 20￥/GB<br>Dynamic Long-term ISP: 130￥/GB',
        // FAQ Data - Pricing (second tab continued)
        faq18q: lang === 'zh' ? '额度套餐充值后可以使用哪些套餐类型？' : 'Which package types can be used after recharging the credit package?',
        faq18a: lang === 'zh' ? '账户额度有两种使用方式：<br>1、动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费。<br>2、静态住宅/独享数据中心，支持使用账户额度购买对应套餐。' : 'There are two ways to use account credit:<br>1. Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, charged according to proxy usage.<br>2. Static Residential/Dedicated Data Center, support using account credit to purchase corresponding packages.',
        faq19q: lang === 'zh' ? '如果IP过期了，续费后可以继续使用同一个IP吗？' : 'If the IP expires, can I continue to use the same IP after renewing?',
        faq19a: lang === 'zh' ? 'IP过期后无法续费，请注意过期时间并在IP到期前续费' : 'IP cannot be renewed after expiration. Please pay attention to the expiration time and renew before the IP expires.',
        faq20q: lang === 'zh' ? '静态住宅IP有流量限制吗？' : 'Is there a traffic limit for static residential IP?',
        faq20a: lang === 'zh' ? '按照数量计费，没有流量限制' : 'Charged by quantity, no traffic limit.',
        faq21q: lang === 'zh' ? '独享数据中心和动态数据中心有什么区别？' : 'What is the difference between dedicated data center and dynamic data center?',
        faq21a: lang === 'zh' ? '两种IP都来自IDC机房，标记为机房IP<br>动态数据中心按照流量计费，自定义1-30min IP时效，高效轮转<br>独享数据中心按照IP数量计费，是个人专享使用的长效IP地址，可选择周/月/季或定制IP时效' : 'Both IPs come from IDC computer rooms and are marked as computer room IPs.<br>Dynamic data center is charged according to traffic, with custom 1-30min IP validity period, efficient rotation.<br>Dedicated data center is charged according to the number of IPs, which is a long-term IP address exclusively for personal use, with optional weekly/monthly/quarterly or customized IP validity period.',
        faq22q: lang === 'zh' ? '额度套餐与产品套餐有什么区别？' : 'What is the difference between credit package and product package?',
        faq22a: lang === 'zh' ? '产品套餐：根据业务需要选择动态住宅、静态住宅、数据中心、动态ISP或移动代理，套餐时效<br>包括周套餐、月套餐、季度套餐或定制时效，套餐到期将清空流量。<br>额度套餐：根据需要选择充值额度，充值的额度可以使用ProxyLink所有代理类型。<br>动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费，随用随扣；<br>静态住宅/独享数据中心，支持使用账户额度购买对应套餐。' : 'Product package: Choose dynamic residential, static residential, data center, dynamic ISP or mobile proxy according to business needs, package validity period<br>including weekly package, monthly package, quarterly package or customized validity period, the package will clear traffic when it expires.<br>Credit package: Choose recharge amount according to needs, the recharged amount can use all ProxyLink proxy types.<br>Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, charged according to proxy usage, deducted as you use;<br>Static Residential/Dedicated Data Center, support using account credit to purchase corresponding packages.',
        faq23q: lang === 'zh' ? '未使用完的流量能否转存到下个月？' : 'Can unused traffic be carried over to next month?',
        faq23a: lang === 'zh' ? '若您购买了 动态住宅包月套餐，流量未在1个月内使用完，则不可转存到下个月，<br>您可在购买前考虑好用量，选择适合您的月度套餐；若您购买了 额度套餐，<br>则按照使用量扣费，流量使用无时效问题，随用随扣。' : 'If you purchase a monthly dynamic residential package and the traffic is not used up within 1 month, it cannot be carried over to the next month.<br>You can consider your usage before purchasing and choose a monthly package suitable for you; if you purchase a credit package,<br>it is charged according to usage, and there is no time limit for traffic usage, deducted as you use.',
        faq24q: lang === 'zh' ? 'ProxyLink是否支持城市级定位？' : 'Does ProxyLink support city-level positioning?',
        faq24a: lang === 'zh' ? 'ProxyLink支持多个国家的城市精准定位，您可从指定的国家城市访问目标网站，详情可咨询 客户经理。' : 'ProxyLink supports precise city positioning in multiple countries. You can access target websites from designated countries and cities. For details, please consult the account manager.',
        // FAQ Data - Account (third tab)
        faq25q: lang === 'zh' ? 'IP限制使用终端设备数量吗' : 'Does IP limit the number of terminal devices used?',
        faq25a: lang === 'zh' ? '动态按照流量计费，对并发和同时连接数没有限制。' : 'Dynamic is charged according to traffic, with no restrictions on concurrency and simultaneous connections.',
        faq26q: lang === 'zh' ? '账密认证如何使用？' : 'How to use account password authentication?',
        faq26a: lang === 'zh' ? '账密认证是通过主账户创建认证账户进行流量分配。用户可以通过创建多个“认证账户”，给每个认证账户设置流量额度，根据业务需求灵活使用。具体操作参照“账密认证使用教程”。' : 'Account password authentication allocates traffic by creating authentication accounts through the main account. Users can create multiple "authentication accounts", set traffic quotas for each, and use them flexibly according to business needs. For specific operations, refer to the "Account Password Authentication Usage Tutorial".',
        faq27q: lang === 'zh' ? '服务器IP被多个账号加入白名单会怎样？' : 'What happens if a server IP is added to the whitelist by multiple accounts?',
        faq27a: lang === 'zh' ? '例如A、B两个帐号同时使用一个服务器，服务器IP保存在A账户，则扣除A账户流量，如在B账户，则扣除B账户流量；如服务器IP已保存在A账户，B账户再次添加，则会顶到A账户服务器IP留存，使用流量则扣除B账户' : 'For example, if accounts A and B use the same server, and the server IP is saved in account A, traffic will be deducted from account A; if in account B, traffic will be deducted from account B. If the server IP has been saved in account A, and account B adds it again, it will replace the server IP retention in account A, and traffic will be deducted from account B when used.',
        faq28q: lang === 'zh' ? '链接生成的IP可以一直使用吗？' : 'Can the IP generated by the link be used permanently?',
        faq28a: lang === 'zh' ? 'api代理模式，会不定时升级维护服务器，IP和端口也会改变，不建议长时间一直用一个IP段，可以每几天获取换一次。如果是账密代理模式可以一直用。' : 'In API proxy mode, servers are upgraded and maintained from time to time, and IPs and ports will also change. It is not recommended to use one IP segment for a long time. You can obtain and change it every few days. If it is account password proxy mode, it can be used permanently.',
        // FAQ Data - Troubleshooting (fourth tab)
        faq29q: lang === 'zh' ? '账户有流量，生成API链接提示额度不足' : 'Account has traffic, but generating API link prompts insufficient credit',
        faq29a: lang === 'zh' ? '请在ProxyLink账户后台检查是否添加白名单，添加白名单后再次获取API链接，若已添加，删掉白名单重新添加，再次获取API链接' : 'Please check if you have added a whitelist in the ProxyLink account backend. After adding the whitelist, obtain the API link again. If it has been added, delete the whitelist and re-add it, then obtain the API link again.',
        faq30q: lang === 'zh' ? '如何通过程序判断代理是否失效' : 'How to judge if a proxy is invalid through a program?',
        faq30a: lang === 'zh' ? '官网后台可以设置IP时效，动态最长可以设置30分钟，IP是隧道转发的，失效后会自动切换' : 'You can set IP validity period in the official website backend. The maximum dynamic validity period can be set to 30 minutes. IP is tunnel forwarded and will automatically switch after invalidation.'
      };
    },
    tabs() {
      return [
        { value: 'first', label: this.t.tabGettingStarted },
        { value: 'second', label: this.t.tabPricing },
        { value: 'third', label: this.t.tabAccount },
        { value: 'fourth', label: this.t.tabTroubleshooting }
      ];
    },
    faqData() {
      return {
        first: [
          {
            question: this.t.faq1q,
            answer: this.t.faq1a
          },
          {
            question: this.t.faq2q,
            answer: this.t.faq2a
          },
          {
            question: this.t.faq3q,
            answer: this.t.faq3a
          },
          {
            question: this.t.faq4q,
            answer: this.t.faq4a
          },
          {
            question: this.t.faq5q,
            answer: this.t.faq5a
          },
          {
            question: this.t.faq6q,
            answer: this.t.faq6a
          },
          {
            question: this.t.faq7q,
            answer: this.t.faq7a
          },
          {
            question: this.t.faq8q,
            answer: this.t.faq8a
          },
          {
            question: this.t.faq9q,
            answer: this.t.faq9a
          },
          {
            question: this.t.faq10q,
            answer: this.t.faq10a
          },
          {
            question: this.t.faq11q,
            answer: this.t.faq11a
          }
        ],
        second: [
          {
            question: this.t.faq12q,
            answer: this.t.faq12a
          },
          {
            question: this.t.faq13q,
            answer: this.t.faq13a
          },
          {
            question: this.t.faq14q,
            answer: this.t.faq14a
          },
          {
            question: this.t.faq15q,
            answer: this.t.faq15a
          },
          {
            question: this.t.faq16q,
            answer: this.t.faq16a
          },
          {
            question: this.t.faq17q,
            answer: this.t.faq17a
          },
          {
            question: this.t.faq18q,
            answer: this.t.faq18a
          },
          {
            question: this.t.faq19q,
            answer: this.t.faq19a
          },
          {
            question: this.t.faq20q,
            answer: this.t.faq20a
          },
          {
            question: this.t.faq21q,
            answer: this.t.faq21a
          },
          {
            question: this.t.faq22q,
            answer: this.t.faq22a
          },
          {
            question: this.t.faq23q,
            answer: this.t.faq23a
          },
          {
            question: this.t.faq24q,
            answer: this.t.faq24a
          }
        ],
        third: [
          {
            question: this.t.faq25q,
            answer: this.t.faq25a
          },
          {
            question: this.t.faq26q,
            answer: this.t.faq26a
          },
          {
            question: this.t.faq27q,
            answer: this.t.faq27a
          },
          {
            question: this.t.faq28q,
            answer: this.t.faq28a
          }
        ],
        fourth: [
          {
            question: this.t.faq29q,
            answer: this.t.faq29a
          },
          {
            question: this.t.faq30q,
            answer: this.t.faq30a
          }
        ]
      };
    }
  },
  methods: {
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = null;
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航链接点击
    handleMobileNavClick(targetRoute) {
      // 检查当前路由是否与目标路由相同
      if (this.$route.path === targetRoute) {
        // 关闭移动端菜单
        this.isMobileMenuOpen = false;
        // 重置下拉菜单
        this.activeDropdown = null;
        // 切换按钮样式
        const menuButton = document.getElementById('meanmenu-reveal');
        if (menuButton) {
          menuButton.classList.remove('active');
        }
      }
    },
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    handleScroll() {
      const scrollPosition = window.pageYOffset;
      this.showGoTop = scrollPosition > 300;
      this.isSticky = scrollPosition > 100;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    toggleAccordion(tab, index) {
      if (this.activeAccordion[tab] === index) {
        this.activeAccordion[tab] = null;
      } else {
        this.activeAccordion[tab] = index;
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #4146E6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

/* Default Button Styles */
.default-btn {
  display: inline-block;
  border: none;
  box-shadow: 0;
  transition: var(--transition);
  text-decoration: none;
  background-color: var(--mainColor);
  color: var(--whiteColor);
  padding: 12px 35px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
}

.default-btn:hover {
  color: var(--whiteColor);
}

.default-btn:hover::before {
  opacity: 0;
  visibility: hidden;
}

.default-btn::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  opacity: 1;
  visibility: visible;
  border-radius: 5px;
  transition: var(--transition);
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
}

/* Container Styles */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Padding Styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-100 {
  padding-bottom: 100px;
}

/* Background Styles */
.bg-light {
  background-color: #f8f9fa;
}
/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
</style>

<style scoped>
.faq-banner-section {
  background-color: #F7FAFD;
  text-align: center;
}

.faq-banner-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #2c3e50;
  position: relative;
  display: inline-block;
  line-height: 1.3;
}

/* 首字母样式和下划线 */
.faq-banner-section h1::before {
  content: attr(data-first-letter);
  position: relative;
  display: inline-block;
  margin-right: 3px;
}

/* 使用::after在首字母下方创建下划线 */
.faq-banner-section h1::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: linear-gradient(135deg, #4146E6 0%, #6a30d1 100%);
  border-radius: 2px;
  transform: translateY(5px);
}

/* 中文标题特殊处理 */
.faq-banner-section h1:lang(zh)::after {
  width: 25px;
  left: 50%;
  transform: translateX(-50%) translateY(5px);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .faq-banner-section h1::after {
    width: 25px;
    height: 3px;
    transform: translateY(4px);
  }
  
  .faq-banner-section h1:lang(zh)::after {
    width: 20px;
  }
}

@media (max-width: 480px) {
  .faq-banner-section h1::after {
    width: 20px;
    height: 3px;
    transform: translateY(3px);
  }
  
  .faq-banner-section h1:lang(zh)::after {
    width: 18px;
  }
}

.faq-banner-section p {
  font-size: 1.125rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
}

/* FAQ Tabs */
.faq-tabs {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid #f0f2f5;
}

.tabs-container {
  display: flex;
  flex-direction: column;
}

.tab-buttons {
  display: flex;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: none;
  padding: 10px;
  gap: 10px;
}

.tab-btn {
  flex: 1;
  padding: 16px 24px;
  border: none;
  background: #fff;
  font-size: 1.05rem;
  font-weight: 600;
  color: #666;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}

.tab-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
  transform: scaleX(0);
  transition: transform 0.4s ease;
}

.tab-btn:hover {
  background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 100%);
  color: #007bff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.15);
}

.tab-btn.active {
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(106, 48, 209, 0.3);
}

.tab-btn.active::before {
  transform: scaleX(1);
}

.tab-content {
  padding: 40px;
  background: #fff;
}

/* FAQ Accordion */
.faq-accordion {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.accordion-item {
  background: #fff;
  border: 1px solid #e8f0ff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.accordion-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
  transform: scaleY(0);
  transition: transform 0.4s ease;
}

.accordion-item:hover {
  box-shadow: 0 8px 32px rgba(0, 123, 255, 0.12);
  transform: translateY(-3px);
  border-color: #007bff;
}

.accordion-item:hover::before {
  transform: scaleY(1);
}

.accordion-item.active {
  box-shadow: 0 12px 40px rgba(0, 123, 255, 0.15);
  border-color: #007bff;
}

.accordion-item.active::before {
  transform: scaleY(1);
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  background: #fafbff;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 2;
}

.accordion-item.active .accordion-header {
  background: linear-gradient(135deg, #6a30d1 0%, #5c83e3 100%);
  color: #fff;
}

.accordion-header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #2c3e50;
  transition: all 0.4s ease;
  line-height: 1.4;
  flex: 1;
  margin-right: 20px;
}

.accordion-item.active .accordion-header h3 {
  color: #fff;
}

.accordion-icon {
  font-size: 1.8rem;
  font-weight: bold;
  color: #999;
  transition: all 0.4s ease;
  background: #fff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.accordion-item:hover .accordion-icon {
  color: #007bff;
  transform: rotate(90deg);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.accordion-item.active .accordion-icon {
  color: #007bff;
  transform: rotate(180deg);
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.2);
}

.accordion-body {
  padding: 0 30px 30px;
  background: #fff;
  border-top: none;
  overflow: hidden;
}

.accordion-body p {
  margin: 0;
  color: #555;
  line-height: 1.8;
  font-size: 1.05rem;
  padding: 24px 0 0;
  border-top: 1px solid #f0f2f5;
}

.accordion-item.active .accordion-body {
  background: #fafbff;
}

.accordion-item.active .accordion-body p {
  color: #444;
}

/* Animation for accordion body */
.accordion-body {
  max-height: 0;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-item.active .accordion-body {
  max-height: 500px;
  opacity: 1;
  padding: 0 30px 30px;
}

/* Enhanced hover effects for accordion body */
.accordion-body p {
  transition: all 0.4s ease;
}

.accordion-item:hover .accordion-body p {
  color: #333;
}

/* Footer Styles */
.footer-section {
  background: #3B566E;
  color: #fff;
  padding: 100px 0 0;
}

.footer-widget {
  margin-bottom: 30px;
}

.footer-widget h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #fff;
}

.footer-widget.pl-4 {
  /* padding-left: 30px; */
}

.footer-contact-info {
  list-style: none;
  padding: 0;
}

.footer-contact-info li {
  margin-bottom: 15px;
  color: #ddd;
  line-height: 1.6;
}

.footer-contact-info a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer-contact-info a:hover {
  color: #007bff;
}

.links-list {
  list-style: none;
  padding: 0;
}

.links-list li {
  margin-bottom: 15px;
}

.links-list a {
  color: #ddd;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px;
  display: block;
}

.links-list a:hover {
  color: #007bff;
  padding-left: 5px;
}

.logo {
  display: inline-block;
  /* margin-bottom: 20px; */
}

.logo a {
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  text-decoration: none;
}

.logo-text {
  color: #fff;
}

.social-links {
  list-style: none;
  padding: 0;
  display: flex;
  margin-top: 20px;
}

.social-links li {
  margin-right: 15px;
}

.social-links a {
  color: #fff;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-links a:hover {
  background: #007bff;
  transform: translateY(-3px);
}

.footer-widget p {
  color: #ddd;
  line-height: 1.6;
  margin-bottom: 20px;
}

.copyright-area {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px 0;
  margin-top: 30px;
}

.copyright-area p {
  color: #ddd;
  margin: 0;
  text-align: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .faq-banner-section {
    padding: 80px 20px;
  }
  
  .faq-banner-section h1 {
    font-size: 2.2rem;
  }
  
  .faq-banner-section p {
    font-size: 1.1rem;
  }
  
  .tab-buttons {
    flex-direction: column;
    gap: 8px;
  }
  
  .tab-btn {
    text-align: left;
    font-size: 1rem;
    padding: 14px 18px;
  }
  
  .tab-content {
    padding: 25px;
  }
  
  .accordion-header {
    padding: 18px;
  }
  
  .accordion-header h3 {
    font-size: 1rem;
  }
  
  .accordion-body {
    padding: 20px;
  }
  
  .accordion-body p {
    font-size: 0.95rem;
  }
  
  .accordion-icon {
    font-size: 1.5rem;
    width: 28px;
    height: 28px;
  }
}

@media (max-width: 480px) {
  .faq-banner-section h1 {
    font-size: 1.8rem;
  }
  
  .faq-banner-section p {
    font-size: 1rem;
  }
  
  .tab-content {
    padding: 20px 15px;
  }
  
  .accordion-header {
    padding: 15px;
  }
  
  .accordion-header h3 {
    font-size: 0.95rem;
  }
  
  .accordion-body {
    padding: 15px;
  }
  
  .accordion-body p {
    font-size: 0.9rem;
  }
}

/* Go Top Button */
.go-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 40px;
  height: 40px;
  background: #007bff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.go-top.active {
  opacity: 1;
  visibility: visible;
}

.go-top:hover {
  background: #0056b3;
  transform: translateY(-3px);
}
</style>